import { TechemTheme } from '@techem/techem-theme';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import infoIcon from '../../../../assets/icons/png/3x/icn-info@3x-schwarz.png';
import ExternalArrowLink from '../../../../../presentation/components/ExternalArrowLink';
import Icon, { ICONSIZE } from '../../../../../presentation/components/Icon';
import { ContentWrapper } from '../../../../components/offerpage/ContentWrapper';
import { useMediaQuery } from '../../../../../tools/hooks/useMediaQuery';
import CenteredContent from './CenteredContent';
import HighlightedEntryRow from './styled/HighlightedEntryRow';

const TECHEM_CONTACT_URL =
  'https://www.techem.com/de/de/info-und-service/kontakt/kontaktformular-neukunden';

const ContactPartnerInfoBox: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isXXSmall = useMediaQuery('(max-width: 375px)');

  return (
    <HighlightedEntryRow
      className={`justify-content-center px-3 py-4 my-3`}
      data-gi="contract-partner-info"
    >
      <Col xs={12} md className={`${isXXSmall ? 'px-0' : ''}`}>
        <Row>
          <Col xs="auto" className="pe-0 ps-3" style={{ width: '40px' }}>
            <Icon iconSrc={infoIcon} size={ICONSIZE.small} alt="Information Icon" />
          </Col>
          <Col xs>
            <CenteredContent>
              <strong>
                <ContentWrapper
                  color={TechemTheme.colors.contentPrimary}
                  i18nKey={'pages.offer.infoBoxes.contractPartner.title'}
                />
              </strong>
            </CenteredContent>
          </Col>
          <Col xs={12} md={11} className="my-3 ms-md-5 ps-md-2">
            <span className="copy d-inline-block">
              <ContentWrapper
                color={TechemTheme.colors.contentPrimary}
                i18nKey={'pages.offer.infoBoxes.contractPartner.description'}
              />
              <ExternalArrowLink url={TECHEM_CONTACT_URL}>hier.</ExternalArrowLink>
            </span>
          </Col>
        </Row>
      </Col>
      <Col xs={12} md="auto" className={`mw-auto${isXXSmall ? ' px-0' : ''}`}>
        <Row className={`justify-content-between h-100${isMobile ? '' : ' d-grid'}`}>
          <Col
            xs={{ span: 'auto', order: 2 }}
            md={{ order: 1 }}
            className="my-auto my-md-0 px-md-3"
          >
            {
              <Row className="d-block d-md-none position-absolute" style={{ bottom: '32px' }}>
                <Col xs={12}>
                  <span
                    className="copy"
                    style={{
                      textDecoration: 'line-through',
                      color: '#007c94'
                    }}
                  >
                    &shy;
                  </span>
                </Col>
              </Row>
            }

            <Row className="">
              <Col xs={12}>
                <span className="copy text-bold" style={{ color: '#007c94' }}>
                  &shy;
                </span>
              </Col>
            </Row>

            {
              <Row className="mt-3 d-none d-md-block">
                <Col xs={12}>
                  <span
                    className="copy"
                    style={{
                      textDecoration: 'line-through',
                      color: '#007c94'
                    }}
                  >
                    &shy;
                  </span>
                </Col>
              </Row>
            }
          </Col>
          <Col
            xs={{ span: 'auto', order: 1 }}
            md={{ order: 2 }}
            className={`px-2 px-md-3 mt-auto ${isMobile ? 'ms-0' : 'ms-auto'}`}
          >
            &shy;
          </Col>
        </Row>
      </Col>
    </HighlightedEntryRow>
  );
};

export default ContactPartnerInfoBox;
